"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function rvn(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.12347 20.25L9.83697 7.65825L11.3595 17.1083L7.12347 20.25ZM9.88947 7.58625L14.0122 17.118L11.43 17.073L9.88947 7.5855V7.58625ZM9.95097 7.51425L15.351 8.2815L14.1 17.118L9.95097 7.51425ZM14.196 16.9823L15.4132 8.3625L16.2097 9.3735L14.196 16.9823ZM15.3337 8.19975L10.0642 7.4505L14.8087 5.889L15.3337 8.19975ZM10.0387 7.3695L13.2682 5.13075L14.8087 5.808L10.0387 7.3695ZM9.95922 7.3425L10.5817 6.15075L13.2157 5.09475L9.95922 7.3425ZM10.5817 6.0975L10.8787 5.1675L13.0492 5.09475L10.5817 6.09675V6.0975ZM10.8615 5.09475L11.5612 4.3455L13.0672 5.02275L10.8615 5.09475ZM11.6055 4.3005L12.6555 3.786L14.013 5.3745L11.6055 4.3005ZM12.8047 3.849L14.3715 4.53525L14.091 5.3835L12.8047 3.849ZM14.1435 5.4105L14.4322 4.54425L14.7825 5.736L14.1435 5.4105ZM12.6907 3.75H13.8375L14.4052 4.3815C14.4105 4.3876 14.4136 4.39528 14.4139 4.40333C14.4143 4.41137 14.412 4.41931 14.4073 4.42588C14.4027 4.43245 14.3959 4.43726 14.3882 4.43955C14.3805 4.44183 14.3722 4.44147 14.3647 4.4385L12.6907 3.75ZM14.5027 4.47225L16.8352 5.12325C16.847 5.12609 16.8575 5.13281 16.865 5.14233C16.8725 5.15186 16.8766 5.16363 16.8766 5.17575C16.8766 5.18787 16.8725 5.19964 16.865 5.20917C16.8575 5.21869 16.847 5.22541 16.8352 5.22825L14.853 5.772L14.5027 4.47225Z", fill: color }));
}
exports["default"] = rvn;
//# sourceMappingURL=rvn.js.map